// fileActions.js

// Action types
export const SELECT_FILE = 'SELECT_FILE';
export const DESELECT_FILE = 'DESELECT_FILE';
export const SET_SELECTED_URLS = 'SET_SELECTED_URLS';
export const SELECT_PASSPORT_SIZE_PHOTO = 'SELECT_PASSPORT_SIZE_PHOTO';
export const SELECT_REG_NUMBER = 'SELECT_REG_NUMBER';
export const SET_SELECTED_ROWS = 'SET_SELECTED_ROWS';

// Action creators
export const selectFile = (id) => ({
  type: SELECT_FILE,
  payload: id,
});

export const deselectFile = (id) => ({
  type: DESELECT_FILE,
  payload: id,
});

export const setSelectedURLs = (urls) => ({
  type: SET_SELECTED_URLS,
  payload: urls,
});

export const setSelectedRows = (rows) => ({
  type: SET_SELECTED_ROWS,
  payload: rows,
});

export const selectPassportSizePhoto = (url) => ({
  type: SELECT_PASSPORT_SIZE_PHOTO,
  payload: url,
});

export const selectRegNumber = (regNumber) => ({
  type: SELECT_REG_NUMBER,
  payload: regNumber,
});